(() => {
  /* BEZELOR cart v3 helpers (styles in bezelor-cart-v3.css).
     1) Keeps the drawer's empty state, accepted payment cards and popups in sync with the redrawn cart. (There is no countdown: nothing about the cart or offer expires.)
     2) Popups for the shipping, returns, warranty and secure payment tiles. Content comes from <template data-bz-pop-tpl> blocks in the drawer.
     Everything is delegated from document, because the theme redraws the drawer's HTML (scripts inside it would not run). */
  if (window.__bzCartV3) return;
  window.__bzCartV3 = true;

  /* The theme leaves "is-empty" on <cart-drawer> after the first item is added to an empty cart, which hid the close button and the new item.
     The class now follows what is really inside the drawer. */
  const syncEmpty = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const empty = !!drawer.querySelector('.drawer__inner-empty');
    if (drawer.classList.contains('is-empty') !== empty) drawer.classList.toggle('is-empty', empty);
    fillPay();
  };
  const watch = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.bzSync) return;
    drawer.dataset.bzSync = '1';
    new MutationObserver(syncEmpty).observe(drawer, { childList: true, subtree: true });
    syncEmpty();
  };

  /* Accepted payment cards: copied from the theme's <template id="BzPayIcons"> into the slot under the promise tiles. */
  function fillPay() {
    const tpl = document.getElementById('BzPayIcons');
    if (!tpl) return;
    document.querySelectorAll('[data-bz-pay-slot]:empty').forEach((slot) => slot.append(tpl.content.cloneNode(true)));
  }
  const boot = () => {
    watch();
    fillPay();
  };
  document.addEventListener('DOMContentLoaded', boot);
  boot();

  /* ---------- popup ---------- */
  let dialog = null;
  const build = () => {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'bzpop';
    dialog.setAttribute('aria-label', 'BEZELOR information');
    dialog.innerHTML =
      '<p class="bzpop__brand">BEZELOR &middot; Our promise</p>' +
      '<button type="button" class="bzpop__x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="bzpop__in"><div class="bzpop__body"></div></div>';
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('.bzpop__x')) dialog.close();
    });
    document.body.append(dialog);
    return dialog;
  };
  document.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-bz-pop]');
    if (!tile) return;
    const tpl = tile.parentElement.querySelector('template[data-bz-pop-tpl="' + tile.dataset.bzPop + '"]');
    if (!tpl) return;
    const d = build();
    d.querySelector('.bzpop__body').replaceChildren(tpl.content.cloneNode(true));
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
    const first = d.querySelector('.bzpop__x');
    if (first) first.focus({ preventScroll: true });
  });
})();
